import {
  CloseCircleOutlined,
  EnterOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import styled from 'styled-components';

import { CenterFlex, Flex, ShortcutStyle } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Input from '@/components/Inputs/Input';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { isEmptyString } from '@/utils/util';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const SingleKeywordFilter = (props: Props) => {
  const color = useColor();
  const { value, onChange } = props;
  const [isAdding, setIsAdding] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>(value);

  if (isAdding)
    return (
      <Input
        value={inputValue}
        placeholder="Enter to add keyword"
        sizeType="m"
        onChange={(e) => setInputValue(e.target.value)}
        onEnter={() => {
          const text = inputValue.trim();
          setInputValue(text);
          onChange(text);
          setIsAdding(false);
        }}
        style={{
          backgroundColor: color.gray100,
          padding: '4px 16px',
          height: 32,
          borderRadius: 24,
        }}
        wrapperStyle={{
          width: 240,
        }}
        rightIcon={
          <ShortcutStyle outlined>
            <EnterOutlined />
          </ShortcutStyle>
        }
      />
    );

  if (isEmptyString(value))
    return (
      <Style
        onClick={() => {
          setIsAdding(true);
        }}
      >
        <PlusOutlined style={{ fontSize: 14, color: color.gray700 }} />
      </Style>
    );

  return (
    <KeywordStyle height="100%">
      <Flex g={8} a="center">
        <Typo type="label2" className="text-gray-700">
          {value}
        </Typo>
        <IconButton
          icon={<CloseCircleOutlined />}
          onClick={() => {
            onChange('');
            setInputValue('');
          }}
          outlined={false}
          rounded
        />
      </Flex>
    </KeywordStyle>
  );
};

const Style = styled(Flex)`
  min-height: 32px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  background-color: ${(props) => props.theme.colors.gray100};
  padding: 4px 16px;
  border-radius: 16px;
  cursor: pointer;
`;

const KeywordStyle = styled(CenterFlex)`
  min-height: 32px;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.gray100};
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 16px;
  padding-left: 12px;
  padding-right: 4px;
`;

export default SingleKeywordFilter;
